import React from 'react';
import { MapPin } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
const areas = [{
  name: 'Las Vegas',
  position: [36.1699, -115.1398] as [number, number]
}, {
  name: 'North Las Vegas',
  position: [36.1989, -115.1175] as [number, number]
}, {
  name: 'Henderson',
  position: [36.0395, -114.9817] as [number, number]
}];
// Custom teal pin so default Leaflet icon assets aren't needed
const tealIcon = L.divIcon({
  className: '',
  html: `
    <span style="position:relative;display:block;width:28px;height:40px;">
      <svg viewBox="0 0 24 24" width="28" height="40" fill="#15a3a8" stroke="white" stroke-width="1.5" style="filter:drop-shadow(0 2px 3px rgba(0,0,0,0.4));">
        <path d="M12 21s7-7.5 7-12.5A7 7 0 0 0 5 8.5C5 13.5 12 21 12 21z"/>
        <circle cx="12" cy="8.5" r="2.5" fill="white" stroke="none"/>
      </svg>
    </span>
  `,
  iconSize: [28, 40],
  iconAnchor: [14, 40],
  tooltipAnchor: [0, -36]
});
export function ServiceArea() {
  return <section id="service-area" className="py-20 bg-travertine border-y border-taupe/30" data-id="element-152">
      <div className="container mx-auto px-4" data-id="element-153">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10 max-w-5xl mx-auto" data-id="element-154">
          <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-extrabold font-heading text-charcoal mb-4 tracking-tight" data-id="element-156">
              Proudly Serving the Valley
            </h2>
            <p className="text-lg text-charcoal/80 mb-6" data-id="element-157">
              We are a locally owned and operated business, bringing premium
              hardscaping to homes across the Las Vegas metropolitan area.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-158">
              {areas.map(area => <div key={area.name} className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-sand" data-id="element-159">
                  <MapPin className="w-4 h-4 text-teal" data-id="element-160" />
                  <span className="font-bold text-charcoal text-sm" data-id="element-161">
                    {area.name}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="w-full md:w-1/2 flex justify-center" data-id="element-162">
            <div className="relative isolate z-0 w-full max-w-md aspect-square rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-163">
              <MapContainer center={[36.12, -115.08]} zoom={10} scrollWheelZoom={false} className="w-full h-full" style={{
              background: '#ece3d5'
            }} data-id="element-164">
                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-165" />
                {areas.map(area => <Marker key={area.name} position={area.position} icon={tealIcon} data-id="element-166">
                    <Tooltip direction="top" offset={[0, -4]} opacity={1} permanent data-id="element-167">
                      <span className="font-bold text-charcoal text-xs" data-id="element-168">
                        {area.name}
                      </span>
                    </Tooltip>
                  </Marker>)}
              </MapContainer>
            </div>
          </div>
        </div>
      </div>
    </section>;
}